import React, { useEffect, useRef, useState } from 'react';
import { Box, Collapse, IconButton, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faXmark } from '@fortawesome/pro-light-svg-icons';

/*
 * Collapsed to a single icon until used, so two tables can sit side by side
 * without a permanent search field eating the row above each grid.
 */
export const SearchBar = ({ id, label, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) inputRef.current?.focus();
  }, [isOpen]);

  const handleToggle = () => {
    // Closing clears the term so the grid never stays filtered by a hidden field.
    if (isOpen) onChange('');
    setIsOpen((prev) => !prev);
  };

  return (
    <Box className="resourcesTableSearch" id={`${id}__box_search`}>
      <Collapse in={isOpen} orientation="horizontal">
        <TextField
          id={`${id}__textField_search`}
          inputRef={inputRef}
          size="small"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => e.key === 'Escape' && handleToggle()}
          placeholder={`Search ${label}`}
          className="searchField"
          slotProps={{ htmlInput: { 'aria-label': `Search ${label}` } }}
        />
      </Collapse>
      <IconButton
        id={`${id}__iconButton_search`}
        size="small"
        onClick={handleToggle}
        className="searchToggle"
        aria-label={isOpen ? `Close ${label} search` : `Search ${label}`}
        aria-expanded={isOpen}
      >
        <FontAwesomeIcon icon={isOpen ? faXmark : faMagnifyingGlass} />
      </IconButton>
    </Box>
  );
};
